export const useHomeSection = () => useApi<Array<HomeSection<unknown>>>('/home-sections')
